export enum RATING_INFO_TEST_ID {
    RATINGS_CONTAINER = 'rating-info-ratings-container',
    FOLLOWERS_CONTAINER = 'rating-info-followers-container',
}
